<div>
  <nz-space class="report-select">
    <label class="report-label">Select Report: </label>
    <div class="select-report">
      <button type="button" nz-button nz-dropdown [nzDropdownMenu]="menu" class="width-min-sm select-report-btn">
        <div class="select-report-text">
          {{ report?.displayName ?? 'Loading...' }}
        </div>
        <div class="btn-icon" nz-icon nzType="down"></div>
      </button>
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item (click)="selectReport(item)" *ngFor="let item of reports">
            {{ item.displayName }}
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>
  </nz-space>
  <div class="button-container">
    <ng-container *ngTemplateOutlet="prefixActions"></ng-container>
    <!-- <button type="button" nz-button [disabled]="reportUrl === ''" (click)="exportToTXT()"
      [nzLoading]="loading.preview">Export to TXT</button> -->
    <ng-content select="[inquiry]"></ng-content>
    <ng-content select="[exportToTXT]"></ng-content>

    @if (includeBatch) {
    <button type="button" nz-button nzType="primary" [disabled]="reportUrl === ''" (click)="batchEmailClicked.emit()"
      [nzLoading]="loading.batch">Batch Email</button>
    }
    <button type="button" nz-button nzType="primary" [disabled]="reportUrl === ''" (click)="preview()" [nzLoading]="loading.preview">
      Preview
    </button>
    @if(useQueue || this.acl.can('m1.65536')){
    <button type="button" nz-button nz-dropdown [nzDropdownMenu]="viewMenu" nzPlacement="bottomRight"
      [disabled]="reportUrl === ''">
      <span nz-icon nzType="ellipsis"> </span>
    </button>
    <nz-dropdown-menu #viewMenu="nzDropdownMenu">
      <ul nz-menu>
        @if(this.acl.can('m1.65536')){
        <li nz-menu-item (click)="design()" [acl]="designAcl">
          <i nz-icon nzType="edit"></i>
          Design
        </li>
        }
        @if(useQueue){
        <li nz-menu-item (click)="queue()">
          <i nz-icon nzType="mail"></i> Generate & Email
        </li>
        <li nz-menu-item (click)="showTasks()" nz-tooltip="Recent Generate History(7 days)">
          <i nz-icon nzType="history"></i> Recent Generate History
          }
      </ul>
    </nz-dropdown-menu>
    }
  </div>
</div>
<div>
  <pre
    *ngIf="reportUrl ==='GL/PnLAccountWithDetails_MY_MPERS.repx' || reportUrl ==='GL/BalanceSheetAccountWithDetails_MY_MPERS.repx' || reportUrl ==='GL/PnLAccount12Months_MY_MPERS.repx'"
    class="report-mpers"> *MPERS: Malaysian Private Entities Reporting Standards</pre>
</div>

<app-report-clone #clone></app-report-clone>

<app-report-tasks [reportType]="reportType" #tasks></app-report-tasks>
